import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import Iframe from "react-iframe";

function Player(props) {

  const [URL, setURL] = useState(props.videoURL);
  const [canPlay, setcanPlay] = useState(true);
  const handleError = (error) => {
    console.error('Error playing video:', error);
    setcanPlay(false);
  };
  const handlePlay = () => {
    window.speechSynthesis.cancel();
  };
  return (
    <>
      {canPlay ? <ReactPlayer
        url={URL}
        playing={false}
        controls={true}
        className="react-player"
        onError={handleError}
        onPlay={handlePlay}
        />
        :
        <Iframe
          url={URL}
          playing={false}
          controls={true}
          className="react-player"
        />}
    </>
  );
}

export default Player;
